import React, { useEffect, useState } from 'react';
import { api } from '../../utils/api';

const SuperAdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.superadminGetUsers().then(res => setUsers(res.data || [])).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="flex items-center justify-center h-64">
      <div className="w-6 h-6 border-2 border-[hsl(16,100%,55%)] border-t-transparent op-round rounded-full animate-spin" />
    </div>
  );

  return (
    <div className="space-y-6" data-testid="sa-users-page">
      <h2 className="text-xl font-bold tracking-tight">Alla användare ({users.length})</h2>
      <div className="bg-white border border-border rounded overflow-hidden">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-5 py-3 text-left text-xs font-medium text-muted-foreground uppercase">Namn</th>
              <th className="px-5 py-3 text-left text-xs font-medium text-muted-foreground uppercase">E-post</th>
              <th className="px-5 py-3 text-left text-xs font-medium text-muted-foreground uppercase">Roll</th>
              <th className="px-5 py-3 text-left text-xs font-medium text-muted-foreground uppercase">Företag ID</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {users.map((u) => (
              <tr key={u.id}>
                <td className="px-5 py-3 text-sm font-medium">{u.name || '—'}</td>
                <td className="px-5 py-3 text-sm text-muted-foreground">{u.email}</td>
                <td className="px-5 py-3 text-sm">
                  <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${
                    u.role === 'superadmin' ? 'bg-purple-50 text-purple-700' :
                    u.role === 'admin' ? 'bg-blue-50 text-blue-700' :
                    'bg-muted text-muted-foreground'
                  }`}>
                    {u.role}
                  </span>
                </td>
                <td className="px-5 py-3 text-sm text-muted-foreground font-mono text-xs">{u.company_id?.substring(0, 8)}...</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SuperAdminUsers;
